module.exports = __webpack_public_path__ + "static/zelt5-eecafa49ecb8f17f2300ecb7e519916c.jpg";